import { Component, Input, OnInit, OnDestroy, Inject, ViewChild, ElementRef } from '@angular/core';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { DOCUMENT } from '@angular/common';
import { Title } from '@angular/platform-browser';

@Component({
  selector: 'app-dialog',
  templateUrl: './dialog.component.html',
  styleUrls: ['./dialog.component.scss']
})
export class DialogComponent implements OnInit, OnDestroy {
  accepted: boolean;
  @Input() title: string;
  @Input() message: string;
  @Input() btnOkText: string;
  @Input() btnCancelText: string;
  ngbModalRef: HTMLInputElement;
  focusableEls;
  firstFocusableEl ;
  lastFocusableEl;
  KEYCODE_TAB = 9;

  @ViewChild('modalRef') modalRef: ElementRef;

  constructor(
    private activeModal: NgbActiveModal,
    private titleService: Title,
    @Inject(DOCUMENT) private _document: any
  ) {
    this.accepted = false;
    
    
  this.titleService.setTitle('Submission Confirmation');
  }

  ngOnInit() {    
    this.ngbModalRef = this._document.querySelector("ngb-modal-window");
    this.ngbModalRef.setAttribute('aria-labeledby', 'ariaHeading');
    this.ngbModalRef.setAttribute('aria-describedby', 'ariaDescribed');
    this.ngbModalRef && this.ngbModalRef.setAttribute('aria-modal', 'true');
    this.focusableEls = this.modalRef.nativeElement.querySelectorAll('a[href]:not([disabled]), button:not([disabled]), textarea:not([disabled]), input[type="text"]:not([disabled]), input[type="radio"]:not([disabled]), input[type="checkbox"]:not([disabled]), select:not([disabled])');
    this.firstFocusableEl = this.focusableEls[0];
    this.lastFocusableEl = this.focusableEls[this.focusableEls.length - 1];
    this.modalRef.nativeElement.addEventListener('keydown', this.onKeyDown)
  }

  ngOnDestroy() {
    this.ngbModalRef && this.ngbModalRef.removeAttribute('aria-modal');
    this.modalRef.nativeElement.removeEventListener('keydown', this.onKeyDown)
  }

  onKeyDown = (e) => {
    const isTabPressed = (e.key === 'Tab' || e.keyCode === this.KEYCODE_TAB);
      if (!isTabPressed) {
          return;
      }
      if ( e.shiftKey ) /* shift + tab */ {
        if (document.activeElement === this.firstFocusableEl) {
          this.lastFocusableEl.focus();
          e.preventDefault();
        }
      } else /* tab */ {
        if (document.activeElement === this.lastFocusableEl) {
          this.firstFocusableEl.focus();
          e.preventDefault();
        }
      }
  }

  public decline() {
    this.activeModal.close(false);
  }

  public accept() {
    this.accepted = true;
    this.activeModal.close(true);
  }

  public dismiss() {
    this.activeModal.dismiss();
  }



}



// WEBPACK FOOTER //
// ./src/app/features/dialog/dialog.component.ts